import AdvancedController from "./advanced-controller"

export default class VideoController extends AdvancedController {

  static targets = ['video', 'playbutton' ];

  play() {
    if (!this.videoTarget.hasAttribute("controls")) {
      // only show icon in the beginning
      this.videoTarget.setAttribute("controls", "controls"); 
      this.playbuttonTarget.classList.add("--hit-play");
      this.videoTarget.play();
    } else {
      if (this.videoTarget.paused) {
        this.videoTarget.play();
      } else {
        this.videoTarget.pause();
      }
    }
    arguments[0].preventDefault();
  }
}
